import { useTranslation } from "react-i18next";
import { useRealityQuery } from "../Organize.state";
import { FormAutocomplete, RowInfo } from "../../common";
import { VideoLengthModal, VideoSharingModal } from "../modals";
import AugmentedRealityCard from "./AugmentedRealityCard";

const AugmentedRealityVideo = ({ realities, task_id, useQuery }) => {
  const { t } = useTranslation();

  return (
    <>
      <p dangerouslySetInnerHTML={{__html: t(`Require the player to upload a video including an AR model.`)}} />
      <RowInfo help={<VideoLengthModal />}>
        <FormAutocomplete
            label={t("Video length")}
            mode="clean"
            name="video_length"
            useQuery={useQuery}
            options={[
                { id: 1, name: "1s" },
                { id: 2, name: "2s" },
                { id: 3, name: "3s" },
                { id: 5, name: "5s" },
                { id: 7, name: "7s" },
                { id: 10, name: "10s" },
                { id: 20, name: "20s" },
                { id: 30, name: "30s" },
                { id: 45, name: "45s" },
                { id: 60, name: "60s" },
            ]}
            size="small"
            creatable
        />
      </RowInfo>
      <RowInfo help={<VideoSharingModal />}>
        <FormAutocomplete 
            label={t("Shared as")} 
            mode="clean"
            name="task_subtype" 
            useQuery={useQuery}
            options={[
                { id: "0", name: t('standard video') },
                { id: "1", name: t('animated gif') },
                { id: "2", name: t('audio only') },
            ]}
            size="small"
        />
      </RowInfo>
      {realities.map(({ id }) => {
        const useQuery = () => useRealityQuery(task_id, id);
        return <AugmentedRealityCard key={id} useQuery={useQuery} />;
      })}
    </>
  );
};

export default AugmentedRealityVideo;
